// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2ifxt","description":"PatientConsentPreview_description__2kklB"};